/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react";
import PropTypes from "prop-types";
import { ThemeProvider } from "@material-ui/core/styles";
import Theme from "../utils/theme/theme";
import "@fontsource/poppins";
import "./style.css";
import IconLibrary from "./icon-library";

const Layout = (props) => {
  return (
    <ThemeProvider theme={Theme}>
      <IconLibrary />
      {props.children}
    </ThemeProvider>
  );
};

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Layout;
